1// @vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');

// @utilities
const { countActiveFilters } = require('utilities/filtersHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @core
const { FormattedText, getLanguage, formatText } = require('core/i18n').i18n;

// @commons
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');

// @constants
const { DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');


class EmitedTransfersContentFilters extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildAmountFilterLabel() {
        const { immFilter, onResetFilter } = this.props;
        const immFilterAmount = immFilter.get('amount');
        const language = getLanguage();
        let fromElem = null;
        let toElem = null;

        if (immFilterAmount.get('from').get('amount') !== null) {
            const plainAmountObject = getPlainAmountObject(immFilterAmount.get('from'));

            fromElem = (
                <span>
                    <FormattedText value="filters-min" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        className="emited-transfers-content-filters__right-side-value"
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </span>
            );
        }

        if (immFilterAmount.get('to').get('amount') !== null) {
            const plainAmountObject = getPlainAmountObject(immFilterAmount.get('to'));

            toElem = (
                <span>
                    <FormattedText value="filters-max" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        className="emited-transfers-content-filters__right-side-value"
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </span>
            );
        }

        return (
            <LabelFilterRange
                key="filter-amount"
                from={fromElem}
                to={toElem}
                closeCallback={() => {
                    onResetFilter(['amount', 'currency']);
                }}
            />
        );
    }

    buildDateFilterLabel() {
        const { immFilter, onResetFilter } = this.props;
        const immFilterDate = immFilter.get('date');
        const labelFromDate = immFilterDate.get('from').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
        const labelToDate = immFilterDate.get('to').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => {
                    onResetFilter(['date']);
                }}
            />
        );
    }

    buildCurrencyFilterLabel() {
        const { immFilter, onResetFilter } = this.props;
        const labelCurrency = immFilter.getIn(['currency', 'value']);

        return (
            <LabelFilterRange
                key="filter-currency"
                from={labelCurrency}
                closeCallback={() => {
                    onResetFilter(['currency']);
                }}
            />
        );
    }

    buildClearAllFilters() {
        const { immFilter, onClearFilters } = this.props;
        let countFilters = countActiveFilters(immFilter);
        let labelElement;

        if(immFilter.getIn(['amount', 'isActive']) &&  immFilter.getIn(['currency', 'isActive'])) {
            countFilters--;
        }
        if((countFilters) > 1) {
            labelElement = (
                <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={onClearFilters} />
            );
        }

        return labelElement;
    }

    render() {
        const { immFilter } = this.props;
        let filterAmountLabel, filterDateLabel, filterCurrencyLabel;

        if(immFilter.getIn(['amount', 'isActive'])) {
            filterAmountLabel = this.buildAmountFilterLabel();
        }
        if(immFilter.getIn(['date', 'isActive'])) {
            filterDateLabel = this.buildDateFilterLabel();
        }
        if(immFilter.getIn(['currency', 'isActive']) && !filterAmountLabel) {
            filterCurrencyLabel = this.buildCurrencyFilterLabel();
        }

        const clearAllFilters = this.buildClearAllFilters();
        // we can continue doing this for extra filters

        return (
            <section className="emited-transfers-content-filters">
                {filterAmountLabel}
                {filterDateLabel}
                {filterCurrencyLabel}
                {clearAllFilters}
            </section>
        );
    }
}

EmitedTransfersContentFilters.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onResetFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired
}

module.exports = EmitedTransfersContentFilters;
